export default __webpack_public_path__ + "static/media/logo-sec.9e83f20c.png";